<template>
  <div>
    <label class="label" v-if="label">
      {{ label }}
      <span v-if="optional">({{ $t('general.optional') }})</span>
      <n-tooltip v-if="info" :tippyProps="{ content: info }" class="info-icon">
        <n-icon icon="information-circle" size="s" />
      </n-tooltip>
    </label>
    <div class="multi-input" :style="{ minHeight: minHeight ? minHeight + 'px' : 'auto' }" @click="focusEditor">
      <TextEditor
        ref="textEditor"
        :editor="inputEditor"
        :showPlaceholderOnFocusOnly="false"
        :placeholder="placeholder"
        :hideActions="hiddenActions"
        :useFloatingMenu="true"
        :focused="autofocus"
        class="text-editor"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import TextEditor from '@/modules/global/components/TextEditor.vue'
import { Action } from '@/modules/global/components/TextEditorActions.vue'
import { Editor } from '@tiptap/core'
import { createEditor } from '@/util/tiptap-editor-creator'

@Component({
  components: {
    TextEditor
  }
})
export default class NMultilineInput extends Vue {
  @Prop() private placeholder!: any
  @Prop() private value!: string
  @Prop() private minHeight?: number
  @Prop({ default: false, type: Boolean }) autofocus?: boolean
  @Prop({ default: undefined }) label?: string
  @Prop({ default: false, type: Boolean }) optional?: boolean
  @Prop({ default: '' }) info!: string
  private hiddenActions = [Action.LINK]
  private inputEditor: Editor | null = null
  @Ref('textEditor') textEditorRef!: TextEditor

  created() {
    this.inputEditor = createEditor({
      content: this.value,
      getUsers: () => [],
      parent: this,
      enableSlashCommands: false,
      enableIframe: false
    })

    if (this.autofocus) {
      this.$nextTick(() => {
        this.inputEditor?.commands.focus()
      })
    }
  }

  onInput() {
    this.$nextTick(() => {
      this.$emit('input', this.inputEditor?.getHTML())
    })
  }

  focusEditor() {
    this.textEditorRef.editor.commands.focus()
  }

  beforeDestroy() {
    this.inputEditor?.destroy()
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.multi-input {
  max-width: 100%;
  width: 100%;
  background-color: white;
  position: relative;
  box-sizing: border-box;
  outline: 2px solid $notch-color-neutral-sand-200;
  border-radius: $notch-radius-6x;
  padding: $notch-space-2_5x $notch-space-4x;

  &:hover {
    outline-color: $notch-color-neutral-sand-300;
  }

  &:focus-within {
    @include notch-style-focus-outline;
    outline-color: $notch-color-neutral-sand-300;
  }
}

.label {
  @include notch-text-label-light-XS;
  color: $notch-color-neutral-sand-600;
  padding: 0 $notch-space-4x;
  margin-bottom: $notch-space-1x;
  display: flex;
  gap: $notch-space-1_5x;

  .info-icon {
    color: $notch-color-neutral-sand-600;
  }
}
</style>
